<template lang="html">
  <layout-default>
    <main class="page-content" aria-label="Content">
      <div class="wrapper">
        <slot/>
      </div>
    </main>
  </layout-default>
</template>

<script>
import LayoutDefault from './LayoutDefault.vue';

export default {
  name: 'LayoutPage',
  components : {
    LayoutDefault
  }
}
</script>

<style lang="css" scoped>
</style>
